import { makeStyles } from "@material-ui/core/styles";

const useRadioStyles = makeStyles({
  orangeRadio: {
    "&.Mui-checked": {
      color: "#ff9800"
    }
  },
  redRadio: {
    "&.Mui-checked": {
      color: "#f44336"
    }
  },
  blueRadio: {
    "&.Mui-checked": {
      color: "#2196f3"
    }
  }
});

export default useRadioStyles;
